import { portalAPI } from './portalAPI';

import type { Classifier, ClassifierData } from 'types/classifiers';
import { registerClassifierCopy } from 'utils/replayMasking';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APIClassifiersSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['Classifiers', 'ClassifiersMin'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getClassifiersList: builder.query<ClassifierData[], void>({
                query: () => '/v1/classifiers',
                // Load the classifiers list only once in 24 hours
                keepUnusedDataFor: 60 * 60 * 24,
                onQueryStarted: async (_arg, { queryFulfilled }) => {
                    try {
                        const { data } = await queryFulfilled;
                        registerClassifierCopy(data);
                    } catch {
                        // Without the list every classifier label simply stays masked.
                    }
                },
            }),
            getClassifiersWithFilters: accumulatedQueryWithFilters<Classifier>(builder, '/v1/classifiers', {}),
        }),
        overrideExisting: false,
    });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetClassifiersListQuery, useLazyGetClassifiersWithFiltersQuery } = APIClassifiersSlice;
